export default {
  'menu.welcome': '欢迎页面',
  'menu.dashboard': '数据看板',
  'menu.home': '首页',
  'menu.noAuth': '无认证接口',
  'menu.login': '登录页',

  // 组织管理模块
  'menu.organization': '组织管理',
  'menu.organization.orgTree': '组织架构',
  'menu.organization.employee': '员工管理',
  'menu.organization.orgDept': '部门管理',
  'menu.organization.orgPost': '岗位管理',
  'menu.organization.orgConfig': '组织配置',
  // 嵌套路由国际化键
  'menu.organization.orgTree.orgDept': '部门管理',
  'menu.organization.orgTree.employee': '员工管理',
  'menu.organization.orgTree.orgPost': '岗位管理',
  'menu.organization.orgTree.orgConfig': '组织配置',

  // 设备管理模块
  'menu.device': '设备管理',
  'menu.device.deviceManagement': '设备管理',
  'menu.device.deviceModel': '设备型号',
  'menu.device.deviceSupplier': '设备供应商',
  'menu.device.deviceGateway': '设备网关',
  'menu.device.deviceTerminal': '设备终端',

  // 事件管理模块
  'menu.event': '事件管理',
  'menu.event.eventRecord': '事件记录',
  'menu.event.eventOrder': '事件工单',
  'menu.event.eventOrderNode': '工单节点',
  'menu.event.eventReceiver': '事件接收者',
  'menu.event.resourceFile': '资源文件',
  'menu.event.eventType': '事件类型',

  // 套餐管理模块
  'menu.package': '套餐管理',
  'menu.package.myPackage': '我的套餐',
  'menu.package.subPackage': '子级套餐',

  // 系统管理模块
  'menu.system': '系统管理',
  'menu.system.dict': '字典管理',
  'menu.system.menu': '菜单管理',
  'menu.system.role': '角色管理',
  'menu.system.sysConfig': '系统配置',
  'menu.system.noAuth': '无认证接口',

  // 用户管理
  'menu.user': '用户管理',

  // 视频融合模块
  'menu.video': '视频融合',
  'menu.video.preview': '实时预览',
  'menu.video.playback': '历史回放',
  'menu.video.recording': '手动录像',
  'menu.video.fileManagement': '视频文件管理',
  'menu.video.recordingRecord': '录制记录管理',
};
